<template>
  <div class="container">
    <div class="info" v-if="info.id">
      <el-descriptions title="主理人信息">
        <el-descriptions-item label="姓名">{{
          info.name
        }}</el-descriptions-item>
        <el-descriptions-item label="电话">{{
          info.mobile
        }}</el-descriptions-item>
        <el-descriptions-item label="城市">{{
          info.city || ''
        }}{{
          info.district || ''
        }}</el-descriptions-item>
        <el-descriptions-item label="地址">{{
          info.address || ''
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div></div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="合作门店" name="bind"> 
        <bindMechanism ref="bind"></bindMechanism>
      </el-tab-pane>
      <el-tab-pane label="收益" name="income"> 
        <income ref="income" :info="info"></income>
      </el-tab-pane>
      <el-tab-pane label="保证金" name="bond"> 
        <bond ref="bond" :info="info"></bond>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import bindMechanism from './components/details/bindMechanism.vue';
import bond from './components/details/bond.vue';
import income from './components/details/income.vue';
export default {
  components: {
    bindMechanism,
    income,
    bond
  },
  data() {
    return {
      id: "",
      info: {},
      activeName: "bind",
      manager: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
        this.getDetails();
      }
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetails();
  },

  methods: {
    handleClick(tab) {
      this.$refs[tab.name].load();
    },
    getDetails() {
      this.show = true;
      this.$nextTick((_) => {
        this.$refs[this.activeName].load();
      });
      this.$axios({
        url: "/authorization/managerUser/findById",
        params: {
          id: this.id,
        },
      }).then((res) => {
        this.info = res.data.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.info {
  margin-bottom: 30px;
}
</style>